import type { Components } from '@mui/material/styles';

export default function MUIInput(): Components['MuiInput'] {
  return {};
}
